module.exports = __webpack_public_path__ + "static/media/member-emblem-blue.fb1d028a.png";